import React from "react";

// TODO: Aus icon was not working with the "use syntax"

export const AustraliaSvg = ({ width = 22, height = 34 }) => (
  <svg width={width} height={height} viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1131_25451)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.612305 0H33.6123V22H0.612305V0Z"
        fill="url(#paint0_linear_1131_25451)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.612305 0H33.6123V22H0.612305V0Z"
        fill="url(#paint1_linear_1131_25451)"
      />
      <path
        d="M5.32616 4.73751L-1.5127 -0.733154H1.64902L7.14902 2.93351H8.2443L15.5404 -1.32275V0.366846C15.5404 0.811245 15.278 1.28645 14.8836 1.54898L10.0404 4.77711V5.52951L14.97 9.47484C15.696 10.0542 15.2906 11.0002 14.3619 11.0002C13.9769 11.0002 13.5054 10.8594 13.1833 10.6452L8.21759 7.33351H7.1223L-0.173838 11.5898V9.15511L5.32616 5.48844V4.73751Z"
        fill="url(#paint2_linear_1131_25451)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.11231 4.4L0.612305 0H1.39802L6.89802 3.66667H8.46945L14.7552 0V0.366667C14.7493 0.480471 14.717 0.591727 14.6606 0.69276C14.6041 0.793792 14.5249 0.882195 14.4283 0.951867L9.25516 4.4V5.86667L14.4597 10.0305C14.6232 10.1611 14.5729 10.2667 14.3623 10.2667C14.1056 10.2563 13.8567 10.1808 13.6426 10.0481L8.46945 6.6H6.89802L0.612305 10.2667V9.53334L6.11231 5.86667V4.4Z"
        fill="url(#paint3_linear_1131_25451)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.612305 3.66667V6.6H6.1123V10.274C6.1123 10.6744 6.44859 11 6.90587 11H8.46159C8.565 11.0018 8.66774 10.9843 8.76384 10.9486C8.85994 10.9129 8.94747 10.8597 9.02133 10.7922C9.09519 10.7246 9.15391 10.644 9.19405 10.555C9.2342 10.4661 9.25497 10.3705 9.25516 10.274V6.6H14.7709C14.874 6.60004 14.9761 6.58075 15.0711 6.54327C15.1661 6.50578 15.252 6.45087 15.3239 6.38179C15.3957 6.31271 15.4519 6.23086 15.4892 6.14112C15.5264 6.05137 15.544 5.95554 15.5409 5.85933V4.40733C15.543 4.31138 15.5246 4.21599 15.487 4.12669C15.4493 4.03739 15.393 3.95595 15.3214 3.88707C15.2498 3.81819 15.1643 3.76325 15.0698 3.72542C14.9753 3.68758 14.8737 3.66762 14.7709 3.66667H9.25516V0H6.1123V3.66667H0.612305Z"
        fill="url(#paint4_linear_1131_25451)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.612305 4.4H6.89802V0H8.46945V4.4H14.7552V5.86667H8.46945V10.2667H6.89802V5.86667H0.612305V4.4Z"
        fill="url(#paint5_linear_1131_25451)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.68286 17.9669L6.29686 18.6474L6.56243 17.2071L5.44043 16.1863L6.98986 15.9766L7.68286 14.6669L8.37429 15.9766L9.92529 16.1863L8.80329 17.2071L9.06886 18.6474L7.68286 17.9669ZM24.1829 19.0669L23.0719 19.3705L23.3971 18.3335L23.0719 17.2966L24.1829 17.6002L25.2939 17.2966L24.9686 18.3335L25.2939 19.3705L24.1829 19.0669ZM24.1829 5.13355L23.0719 5.43715L23.3971 4.40021L23.0719 3.36328L24.1829 3.66688L25.2939 3.36328L24.9686 4.40021L25.2939 5.43715L24.1829 5.13355ZM28.8971 9.53355L27.7861 9.83715L28.1114 8.80021L27.7861 7.76328L28.8971 8.06688L30.0081 7.76328L29.6829 8.80021L30.0081 9.83715L28.8971 9.53355ZM19.4686 11.0002L18.3576 11.3038L18.6829 10.2669L18.3576 9.22995L19.4686 9.53355L20.5796 9.22995L20.2543 10.2669L20.5796 11.3038L19.4686 11.0002ZM26.54 12.8335L25.9837 12.9861L26.1471 12.4669L25.9837 11.9477L26.54 12.1002L27.0963 11.9477L26.9329 12.4669L27.0963 12.9861L26.54 12.8335Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1131_25451"
        x1="17.1123"
        y1="0"
        x2="17.1123"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F0F0F0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1131_25451"
        x1="17.1123"
        y1="0"
        x2="17.1123"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0A17A7" />
        <stop offset="1" stop-color="#030E88" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1131_25451"
        x1="7.01388"
        y1="-1.32275"
        x2="7.01388"
        y2="11.5898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F0F0F0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1131_25451"
        x1="7.68373"
        y1="0"
        x2="7.68373"
        y2="10.2667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DB1E36" />
        <stop offset="1" stop-color="#D51931" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1131_25451"
        x1="8.07677"
        y1="0"
        x2="8.07677"
        y2="11.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F0F0F0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1131_25451"
        x1="7.68373"
        y1="0"
        x2="7.68373"
        y2="10.2667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DB1E36" />
        <stop offset="1" stop-color="#D51931" />
      </linearGradient>
      <clipPath id="clip0_1131_25451">
        <rect width="33" height="22" fill="white" transform="translate(0.612305)" />
      </clipPath>
    </defs>
  </svg>
);
